export default __webpack_public_path__ + "static/media/lighweight-web.8509eeda.png";